import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DocumentService } from 'src/app/services/document.service';

@Component({
    selector: 'app-upload-document',
    templateUrl: './upload-document.component.html',
    styleUrls: ['./upload-document.component.css'],
    standalone: false
})
export class UploadDocumentComponent {
  private documentService = inject(DocumentService);
  private messageService = inject(MessageService);


  @Input() record: any;
  selectedFile!:File;
  isUploading = false;
  isNotesUpdated = false;
  notes!: string;
  folders = null;
  @Output() updateValue = new EventEmitter();


  onFileChanged(event: any)
  {
    this.selectedFile = event.target.files[0];
    if(this.selectedFile.size/(1024*1024) > 2){
      this.messageService.add({
        severity: 'error',
        summary: 'Document Upload',
        detail: 'Document size should be less than 3mb.'
      });
      return 
    }
    this.uploadDocument();
  }

  uploadDocument(){
    if(this.isUploading == true)
    return
    this.isUploading = true;
    const fd = new FormData();
    fd.append("file",this.selectedFile);
    fd.append("adminId",this.record["lanId"]);
    fd.append("notes",this.notes);
    if(this.folders || this.folders != null) {
      fd.append("folders",this.folders);
    }
    if(this.record["maapKey"]){
      fd.append("maapKey",this.record["maapKey"]);
    }
    if(typeof this.record.totalVariance === "undefined")
    fd.append("record_id",this.record["id"]);
    this.documentService.uploadDocument(fd).subscribe(()=>{
      this.isUploading = false;
      this.documentService.tab = 2
      this.messageService.add({
        severity: 'success',
        summary: 'Document Upload',
        detail: 'Document uploaded successfully.'
      });
      this.updateValue.emit(1);
    }, () => {
      this.messageService.add({
        severity: 'error',
        summary: 'Document Upload',
        detail: 'Document upload failed.'
      });
      this.isUploading = false;
    }
    );
  }

  updateNotes(){
    this.isNotesUpdated = true;
  }

}
